<template>
  <div class="navigations">
    <div class="navigation">
      <el-button class="btn-submit" @click="editColumn"  icon="el-icon-plus">新增</el-button>
    </div>
    <el-table :header-cell-style="{background:'#f5f5f5',color:'rgb(82,82,82)',fontSize:'16px',fontWeight:400}" :data="tableData"  element-loading-text="拼命加载中" class="m-table">
      <el-table-column prop="name" label="权限名称" align="center"></el-table-column>
      <el-table-column prop="menu_name" label="权限" width="800" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" >
        <template slot-scope="scope">
          <div v-if="roleName=='administrator'">
            <span v-if="scope.row.id!=1" class="nav" @click="editColumn(scope.$index,scope.row)"><i class="el-icon-bianji"></i> 修改</span>
            <span v-if="scope.row.id!=1">|</span>
            <span v-if="scope.row.id!=1" class="nav" @click="delColumn(scope.$index,scope.row)" style="color:red"><i class="el-icon-delete"></i> 删除</span>
          </div>
          <!-- <div v-else>
            {{scope.row}}
             <span v-if="roleName=='administrator'" class="nav" @click="editColumn(scope.$index,scope.row)"><i class="el-icon-bianji"></i> 修改</span>
            <span v-if="roleName=='administrator'">|</span>
            <span v-if="roleName=='administrator'" class="nav" @click="delColumn(scope.$index,scope.row)" style="color:red"><i class="el-icon-delete"></i> 删除</span>
          </div> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange"
    ></Pagination>
    <el-dialog :title="title" :visible.sync="editFormVisible" class="edit-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form class="user-form" :model="userForm" :rules="rules" ref="userForm" label-width="80px">
        <el-form-item label="权限组名">
          <el-input v-model="userForm.name" placeholder="请输入权限组名"></el-input>
        </el-form-item>


        <el-form-item label="权限">
          <el-tree
            :data="permissionData"
            show-checkbox
            default-expand-all
            node-key="id"
            :check-strictly="true"
            :default-expanded-keys="permissionData"
            :default-checked-keys="defaultCheck"
            :props="defaultProps"
            ref="tree">
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-submit" type="primary" @click="submitForm('userForm')">确定</el-button>
        <el-button class="btn-cancel" @click="editFormVisible=false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {getMenu2,getRoleMenu} from "../../api/userMG";
  import {getRoleList,addRole,editRole,delRole} from "../../api/setting";
  import Pagination from "../../components/Pagination";
  export default {
    data(){
      return{
        title:'新增',
        editFormVisible:false,
        tableData:[],
        // 分页参数
        currentPage: 1,
        
        limit: 10,
        total: 0,
        menuList:[],
        roleList:[],
        roleName:localStorage.getItem('roleName'),
        user: localStorage.getItem("name"),
        userForm:{
          id:'',
          name:'',
          slug:'',
        },
        permissionData:[],
        defaultCheck:[],//默认选中权限
        defaultProps:{
          children: 'child',
          label: 'title'
        },
        //  规则验证
        rules:{
          name:[{required:true,message: '请输入角色名', trigger: 'change'}],
          slug:[{required:true,message: '请输入标识', trigger: 'change'}],
        }
      }
    },
    methods:{
      //获取列表数据
      getData(){
        let params={
          token:localStorage.getItem('token'),
          page:this.currentPage
        }
        getRoleList(params ).then(res=>{
          if(res.errno===0){
            this.tableData=res.data.data
            this.limit=res.data.per_page
            this.total=res.data.total
          }
          else if(res.errno===401){
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          }
          else{
            this.$message.error(res.error)
          }
        })
      },
      //获取菜单列表
      getMenuList(){
        let params={
          token:localStorage.getItem('token'),
        }
        getMenu2(params).then(res=>{
          if(res.errno===0){
            this.permissionData=res.data
          }
        })
      },
      //获取选中菜单
      getDefaultMenu(id){
        return new Promise((resolve,reject)=> {
          let params={
            id:id,
            token:localStorage.getItem('token')
          }
          var data=[]
          getRoleMenu(params).then(res=>{
            if(res.errno===0){
              for(var i=0;i<res.data.menus.length;i++){
                data.push(res.data.menus[i].menu_id)
              }
              resolve(data)
            }
          })
        })

      },
      //编辑或者新增
      async editColumn(index,row){
        this.editFormVisible=true
        if(row==''||row==undefined){
          this.title='新增'
          this.userForm.id=''
          this.userForm.name=''
          this.userForm.slug=''
          this.defaultCheck=[]
          this.getMenuList()
          this.editFormVisible=true
        }
        else{
          this.title='编辑'
          this.userForm.id=row.id
          this.userForm.name=row.name
          this.userForm.slug=row.slug
          this.getMenuList()
          this.defaultCheck=[]
          this.defaultCheck=await this.getDefaultMenu(row.id)
        }
      },
      submitForm(formName){
        this.$refs[formName].validate((valid)=>{
          if(valid){
            if(this.userForm.id==''){
              var roleArray=this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
              let params={
                token:localStorage.getItem('token'),
                name:this.userForm.name,
                // slug:this.userForm.slug,
                menu_ids:roleArray.join(',')
              }
              addRole(params).then(res=>{
                if(res.errno===0){
                  this.$message({
                    type:"success",
                    message:res.data
                  })
                  this.editFormVisible=false
                  this.getData()
                }
                else if(res.errno===401){
                  this.$store.dispatch('LogOut').then(() => {
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                  })
                }
                else{
                  this.$message.error(res.error)
                }
              })
            }
            else{
              var roleArray=this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())

              let params={
                id:this.userForm.id,
                token:localStorage.getItem('token'),
                name:this.userForm.name,
                // slug:this.userForm.slug,
                menu_ids:roleArray.join(',')
              }

              editRole(params).then(res=>{
                if(res.errno===0){
                  this.$message({
                    type:"success",
                    message:res.data
                  })
                  this.editFormVisible=false
                  this.getData()
                }
                else if(res.errno===401){
                  this.$store.dispatch('LogOut').then(() => {
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                  })
                }
                else{
                  this.$message.error(res.error)
                }
              })
            }
          }
        })
      },
      // 详情
      detailColumn(index,row){

      },
      //删除
      delColumn(index,row){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          let params={
            id:row.id,
            token:localStorage.getItem('token')
          }
          delRole(params).then(res=>{
            if (res.errno === 0) {
              this.$message({
                type: 'success',
                message: res.data
              })
              this.getData()
            } else if(res.errno===401){
              this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
            }
            else{
              this.$message.error(res.error)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('删除失败,请稍后再试！')
          })
        }).catch(err => {
          this.loading = false
        })
      },
      //翻页
      handleCurrentChange(val){
        this.currentPage=val
        this.getData()
      },

    },
    mounted() {
      this.getData()

    },
    components:{
      Pagination,
    }
  }
</script>
<style scoped>
  .m-breadcrump{
    display: flex;
    border-bottom: 1px solid #a5b0d3;
    line-height: 32px;
    color: #0f215d;
    margin-bottom: 50px;
  }
  .edit-dialog >>> .el-dialog{
    width: 30%;
    max-height: 80%;
    overflow-y: auto;
  }
   .navigation  {
    /* cursor: pointer; 使文字可点击*/
    margin-bottom: 20px;
  }
  /* .navigations{
    padding: 10px;
  } */
 .nav {
  cursor: pointer;
  color: #2b52e9;
  margin-right: 8px;
}
.nav i{
  margin-right: 5px;
  margin-left: 8px;
}
.edit-dialog>>>.el-input__inner{
  /* width: 394px; */
  height: 32px;
  color: #999999;
  font-size: 12px;
  border: 1px solid #cccccc;
}
.edit-dialog>>>.el-input__inner:hover{
  border: 1px solid #b0bceb;
  font-size: 12px;
}
.edit-dialog>>>.el-input__inner:focus{
  border:1px solid #2b52e9;
  font-size: 12px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/permission.vue